module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-form"
  }, [_c('el-form', {
    ref: "regCreds",
    attrs: {
      "model": _vm.regCreds,
      "rules": _vm.validators
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    staticClass: "login-input",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    model: {
      value: (_vm.regCreds.username),
      callback: function($$v) {
        _vm.$set(_vm.regCreds, "username", $$v)
      },
      expression: "regCreds.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    staticClass: "login-input",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Password"
    },
    model: {
      value: (_vm.regCreds.password),
      callback: function($$v) {
        _vm.$set(_vm.regCreds, "password", $$v)
      },
      expression: "regCreds.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    staticClass: "login-input",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Confirm Password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.submit('regCreds')
      }
    },
    model: {
      value: (_vm.regCreds.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.regCreds, "checkPass", $$v)
      },
      expression: "regCreds.checkPass"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fpLink",
    on: {
      "click": _vm.changeToLogin
    }
  }, [_vm._v("Already have an account? Click here to sign in.")]), _vm._v(" "), _c('div', {
    staticClass: "login-btns"
  }, [_c('el-button', {
    attrs: {
      "type": "add"
    },
    on: {
      "click": function($event) {
        _vm.submit('regCreds')
      }
    }
  }, [_vm._v("Register")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec31dcee","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegisterForm.vue
// module id = 880
// module chunks = 2